export default __webpack_public_path__ + "static/media/likemovie.f1d2d0a4.webp";